import type { infer as zInfer } from "zod";
import { boolean, object, string } from "zod";

export const getTeamworkCommerceIntegration = {
  name: "getTeamworkCommerceIntegration" as const,
  input: object({}),
  output: object({
    teamworkCommerceIntegration: object({
      baseUrl: string(),
      apiKey: string(),
      importReceiptSettings: object({
        enabled: boolean(),
        exchangeAdjustmentChargeId: string().optional(),
        exchangeAdjustmentMemo: string().optional(),
        fillFromLocationId: string().optional(),
        greenReturnItemSku: string().optional(),
        importReceiptLocationId: string().optional(),
        shippingChargeId: string().optional(),
      }).optional(),
    }).optional(),
  }),
};

export type TeamworkCommerceIntegration = zInfer<
  typeof getTeamworkCommerceIntegration.output
>;
